import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const DataPage = lazy(async () => {
  const m = await import("@/features/data-io/components/data-page");
  return { default: m.DataPage };
});

function DataPageWrapper() {
  return (
    <Suspense fallback={null}>
      <DataPage />
    </Suspense>
  );
}

export const dataRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/data",
  component: DataPageWrapper,
});
